<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="退款单号">
                <el-input v-model="queryParams.orderId" placeholder="请输入单号查询退款信息" clearable></el-input>
            </el-form-item>
            <el-form-item label="退款人姓名">
                <el-input v-model="queryParams.refundUserName" placeholder="请输入退款人姓名查询退款信息" clearable></el-input>
            </el-form-item>
            <el-form-item label="退款人电话">
                <el-input v-model="queryParams.refundPhone" placeholder="请输入退款人电话查询退款信息" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getCategoryList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table
                :data="list"
                style="width: 100%;margin-bottom: 20px;line-height: 0"
                row-key="id"
                show-header>
            <el-table-column label="单号" align="center" prop="orderId"/>
            <el-table-column label="退款原因" align="center" prop="refundReason" />
            <el-table-column label="昵称" align="center" prop="jpNickName" />
            <el-table-column label="联系电话" align="center" prop="jpPhone" />
            <el-table-column label="订单原状态"  align="center" width="120">
                <template slot-scope="scope">
                    <el-tag size="small" type="info" v-if="scope.row.originalOrderStatus=='0'">未接单</el-tag>
                    <el-tag size="small" type="warning" v-else-if="scope.row.originalOrderStatus=='1'">已接单</el-tag>
                    <el-tag size="small" type="primary" v-else-if="scope.row.originalOrderStatus=='2'">配送中</el-tag>
                    <el-tag size="small" type="success" v-else-if="scope.row.originalOrderStatus=='3'">已完成</el-tag>
                    <el-tag size="small" v-else>未知</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="退款状态"  align="center" width="150">
                <template slot-scope="scope">
                    <el-button style="margin-left: 12px" type="success" size="mini" round v-if="scope.row.status=='0'">待退款</el-button>
                    <el-button style="margin-left: 12px" type="warning" size="mini" round v-if="scope.row.status=='1'">已退款</el-button>
                    <el-button style="margin-left: 12px" type="danger" size="mini" round v-if="scope.row.status=='2'">退款失败</el-button>
                </template>
            </el-table-column>

            <el-table-column label="申请退款时间" align="center" prop="createTime" width="280">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="退款成功/失败时间" align="center" prop="updateTime" width="280">
                <template slot-scope="scope">
                    <span>{{ scope.row.updateTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <template v-if="scope.row.status=='0'">
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-edit"
                                @click="confirmRefund(scope.row)"
                        >确认退款</el-button>
                    </template>
                    <template v-if="scope.row.status=='0'">
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-edit"
                                @click="refuseRefund(scope.row)"
                        >拒绝退款</el-button>
                    </template>
                    <el-button
                            size="mini"
                            type="text"
                            style="color: #df5000"
                            icon="el-icon-delete"
                            @click="delList(scope.row)"
                    >删除</el-button>
                </template>

            </el-table-column>
        </el-table>
        <template v-if="list.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>
    </div>
</template>

<script>
    export default {
        props:{
            type:Number
        },
        data() {
            return {
                //类型集合
                typeList:[],
                isDelete:true,
                form: {},
                open:false,
                title: "",
                list: [],//菜单
                //加载状态
                loading: false,
                total: 0,
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    refundUserName:'',//退款人姓名
                    refundPhone:'',//退款人电话
                    orderId:'',//退款单号
                    status:'',//退款状态
                },
            }
        },
        mounted() {
            if (this.type==1){
                this.getCategoryList();
            }if (this.type==2){
                this.queryParams.status='0';
                this.getCategoryList();
            }if (this.type==3){
                this.queryParams.status='1';
                this.getCategoryList();
            }if (this.type==4){
                this.queryParams.status='2';
                this.getCategoryList();
            }
        },
        methods: {
            //拒绝退款
            async refuseRefund(rowData) {
                // 第一步：选择订单处理方式
                this.$confirm('拒绝退款后，订单状态如何处理？', '选择订单状态', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '标记为已完成',
                    cancelButtonText: '返回原有状态',
                    type: 'warning'
                }).then(async () => {
                    // 用户选择：标记为已完成
                    // 第二步：询问是否算取费用
                    this.$confirm(
                        '该订单有兼职接单，是否为兼职和负责人算取费用？\n\n' +
                        '• 算取费用：按正常完成订单的方式给兼职和负责人结算费用\n' +
                        '• 不算费用：仅标记订单为已完成，不进行费用结算',
                        '费用结算选项',
                        {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '算取费用',
                            cancelButtonText: '不算费用',
                            type: 'info'
                        }
                    ).then(async () => {
                        // 用户选择：算取费用
                        const {data: res} = await this.$http.get("refund/refuseRefund", {
                            params: {
                                orderId: rowData.orderId,
                                targetStatus: '3',  // 3表示已完成
                                calculateFee: true  // 算取费用
                            }
                        })
                        console.log(res)
                        if (res.code==200){
                            this.getCategoryList();
                            this.$message.success("退款已驳回，订单已标记为已完成，并已算取费用！")
                        }else {
                            this.$message.error("服务异常，驳回失败，请稍后再试或联系后台工作人员！")
                        }
                    }).catch(async (action) => {
                        if (action === 'cancel') {
                            // 用户选择：不算费用
                            const {data: res} = await this.$http.get("refund/refuseRefund", {
                                params: {
                                    orderId: rowData.orderId,
                                    targetStatus: '3',  // 3表示已完成
                                    calculateFee: false  // 不算费用
                                }
                            })
                            console.log(res)
                            if (res.code==200){
                                this.getCategoryList();
                                this.$message.success("退款已驳回，订单已标记为已完成，未算取费用！")
                            }else {
                                this.$message.error("服务异常，驳回失败，请稍后再试或联系后台工作人员！")
                            }
                        } else {
                            // 用户关闭对话框
                            this.$message.info('已取消操作')
                        }
                    });
                }).catch(async (action) => {
                    if (action === 'cancel') {
                        // 用户选择：返回原有状态
                        const {data: res} = await this.$http.get("refund/refuseRefund", {
                            params: {
                                orderId: rowData.orderId,
                                targetStatus: '0',  // 0表示恢复原状态
                                calculateFee: false  // 不算费用
                            }
                        })
                        console.log(res)
                        if (res.code==200){
                            this.getCategoryList();
                            this.$message.success("退款已驳回，订单已返回原有状态！")
                        }else {
                            this.$message.error("服务异常，驳回失败，请稍后再试或联系后台工作人员！")
                        }
                    } else {
                        // 用户关闭对话框
                        this.$message.info('已取消操作')
                    }
                });
            },

            // 确认退款（新版：由后台统一处理微信退款 + 状态更新）
            confirmRefund(rowData) {
                console.log('确认退款行数据:', rowData);
                this.$confirm('是否确定对该订单执行退款操作？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        // 后端根据退款记录自动调用微信退款（含加价拆分）并更新订单/退款状态
                        const { data: res } = await this.$http.get("refund/updateRefundAndOrderStatus", {
                            params: { orderId: rowData.orderId }
                        });
                        console.log("确认退款返回：", res);
                        if (res.code === 200) {
                            this.getCategoryList();
                            // 组装成功提示（兼容单笔 / 多笔退款返回结构）
                            let msg = '退款操作已完成，订单状态已更新为已退款。';
                            const data = res.data;
                            const pickAccount = (item) => item && (item.user_received_account || item.userReceivedAccount);
                            if (Array.isArray(data) && data.length > 0) {
                                const acc = pickAccount(data[0]);
                                if (acc) msg = `已成功退款，资金将原路退回至 ${acc}。`;
                            } else if (data && typeof data === 'object') {
                                const acc = pickAccount(data);
                                if (acc) msg = `已成功退款，资金将原路退回至 ${acc}。`;
                            }
                            this.$message.success(msg);
                        } else {
                            this.$message.error(res.msg || "退款操作失败，请稍后重试！");
                        }
                    } catch (e) {
                        console.error("确认退款异常：", e);
                        this.$message.error("退款操作异常，请稍后重试！");
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },

            //删除
            async delList(rowData) {
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.get("refund/deleteRefundById/"+rowData.id);
                    if (res.code == 200) {
                        this.getCategoryList();
                        this.$message.success('退款记录删除成功')
                    }else {
                        this.$message.error('删除失败！请稍后再试或联系客服！')
                    }
                }).catch((e) => {
                    this.$message.info('已取消删除！')
                })

            },
            /**
             * 修改按钮操作
             * */
            modifyButton(rowData){
                this.form=rowData;
                this.open=true;
            },
            cancel(){
                this.reset();
                this.open=false;
            },
            reset(){
                this.form={
                    id:0,
                    shopCategoryName:'',
                    sortNum:0,
                    status:"0",
                }
            },
            /**修改用户*/
            async modifyFrom() {
                const {data: res} = await this.$http.post('shopCategory/updateShopCategory',JSON.parse(JSON.stringify(this.form)));
                if (res.code==200){
                    this.$message.success('修改成功')
                    this.getCategoryList();
                }else if(res.code==50013){
                    this.$message.error('店铺分类已存在！')
                }else {
                    this.$message.error('服务器异常')
                }
            },
            /**
             * 添加用户
             * */
            async addFromFun() {
                const {data: res} = await this.$http.post('shopCategory/insertShopCategory', this.form);
                console.log(res)
                if(res.code==200){
                    this.$message.success('添加成功')
                    this.getCategoryList();
                }else if(res.code==50013){
                    this.$message.error('店铺分类已存在!')
                }else{
                    this.$message.error('服务器异常')
                }
            },
            /** 提交按钮 */
            async submitForm() {
                console.log(this.form)
                await this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id != 0) {
                            this.modifyFrom();
                        } else {
                            this.addFromFun();
                        }
                    }
                });
                this.open = false
            },
            //添加按钮操作
            addButton(){
                this.reset();
                this.open=true;
            },
            //重置
            resetQuery(){
                this.queryParams= {
                    pageNum: 1,
                    pageSize: 10,
                    shopName:"",
                    foodShopCategoryId:"",//店铺类型
                    status:"",
                }
                this.getCategoryList();
            },
            /**
             * 获取多选ids
             * **/
            handleSelectionChange(rows) {
                const newArr = []
                rows.forEach((item) => {
                    newArr.push(item.id)
                });
                this.selectedRows = newArr;
                console.log(this.selectedRows)
                if (this.selectedRows.length!=0){
                    this.isDelete=false;
                }else {
                    this.isDelete=true;
                }
            },
            /**
             * 获取退款信息列表
             * @returns {Promise<void>}
             */
            async getCategoryList() {
                const {data: res} = await this.$http.get("refund/getCampusRefundList", {params:this.queryParams});
                console.log(res)
                this.list=res.data.children;
                // console.log(this.list)
                this.total=res.data.total;
            },
            handleSizeChange(val) {
                this.queryParams.pageSize=val;
                this.getCategoryList();
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum=val;
                this.getCategoryList();
            }
        },
    }

</script>

<style scoped>

</style>
